import { BASE_URL } from "@/constants/endpoints";
import {
  ActiveDirectoryUser,
  BOUser,
  Permiso,
} from "@/pages/role-asignation/schema/role-assignation.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let usersBoApiPromise: Promise<AxiosInstance> | null = null;

const getUsersBoApi = () => {
  if (usersBoApiPromise) return usersBoApiPromise;

  usersBoApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return usersBoApiPromise;
};

export interface GetBOUsersProps {
  "P.Pagina": number;
  "P.Records": number;
  NombreApellido?: string;
  Usuario?: string;
  Roles?: number[];
}

export const getBOUsers = async (props: GetBOUsersProps) => {
  const api = await getUsersBoApi();
  if (!api) return null;
  const response = await api.get(
    `/UsuarioRol/GetListadoUsuariosConRol?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export interface GetUserDetailProps {
  Usuario: string;
}

export const getUserDetail = async (
  props: GetUserDetailProps,
): Promise<BOUser | null> => {
  const api = await getUsersBoApi();
  if (!api) return null;
  const response = await api.get(
    `/UsuarioRol/GetUsuarioConRolDetalle?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export interface GetListadoRolesProps {
  nombre?: string;
}

export const getListadoRoles = async (props: GetListadoRolesProps) => {
  const api = await getUsersBoApi();
  if (!api) return null;
  const response = await api.get(
    `UsuarioRol/GetListadoRoles?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export interface UpdateBOUserProps {
  usuario: string;
  rolesAAsignar: number[];
  sucursales: number[];
}

export const getUserPermissions = async (props: {
  usuario: string;
}): Promise<Permiso[] | null> => {
  const api = await getUsersBoApi();
  if (!api) return null;
  const response = await api.get(
    `/UsuarioRol/GetUsuarioPermisos?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export const getListadoPermisos = async () => {
  const api = await getUsersBoApi();
  if (!api) return null;
  const response = await api.get("/UsuarioRol/GetListadoPermisos");
  return response.data;
};

export interface GetRolDetalleProps {
  idRol: number;
}

export const getRolDetalle = async (props: GetRolDetalleProps) => {
  const api = await getUsersBoApi();
  if (!api) return null;
  const response = await api.get(
    `/UsuarioRol/GetRolDetalle?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export interface GetActiveDirectoryUsersProps {
  busqueda?: string;
}

export const getActiveDirectoryUsers = async (props: GetActiveDirectoryUsersProps): Promise<
  ActiveDirectoryUser[] | null
> => {
  const api = await getUsersBoApi();
  if (!api) return null;
  const qs = objectToQueryStringWithArray(props);
  const url = qs
    ? `/UsuarioRol/GetListadoUsuariosAD?${qs}`
    : "/UsuarioRol/GetListadoUsuariosAD";
  const response = await api.get(url);
  return response.data;
};

export const updateBOUser = async (props: UpdateBOUserProps) => {
  const api = await getUsersBoApi();
  if (!api) return null;
  const response = await api.put(`/UsuarioRol/PutAsignarRolesAUsuario`, props);
  return response.data;
};

export interface CreateBOUserProps {
  usuario: string;
  rolesAAsignar: number[];
  sucursales: number[];
  nombreApellido: string;
  mail: string;
}

export const createBOUser = async (props: CreateBOUserProps) => {
  const api = await getUsersBoApi();
  if (!api) return null;
  const response = await api.post(`/UsuarioRol/PostUsuarioConRol`, props);

  return response.data;
};

export interface PostRolProps {
  nombre: string;
  idPermisos: number[];
}

export const postRol = async (props: PostRolProps) => {
  const api = await getUsersBoApi();
  if (!api) return null;
  const response = await api.post("/UsuarioRol/PostRol", props);
  return response.data;
};

export interface PutRolProps {
  id: number;
  nombre?: string;
  idPermisos?: number[];
}

export const putRol = async (props: PutRolProps) => {
  const api = await getUsersBoApi();
  if (!api) return null;
  const response = await api.put("/UsuarioRol/PutRol", props);
  return response.data;
};

export interface DeleteRolProps {
  ids: number[];
}

export const deleteRol = async (props: DeleteRolProps) => {
  const api = await getUsersBoApi();
  if (!api) return null;
  const response = await api.delete(
    `/UsuarioRol/DeleteRol?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export interface DeleteUsersBOProps {
  usuarios: string[];
}

export const deleteUsersBo = async (props: DeleteUsersBOProps) => {
  const api = await getUsersBoApi();
  if (!api) return null;
  const response = await api.delete(
    `/UsuarioRol/DeleteAsignacionRol?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};
